module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "current-info"
  }, [_c('h4', [_vm._v("Tuần số: "), _c('span', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.times))])]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("Mã dự thưởng của bạn:")]), _vm._v(" "), _c('div', {
    staticClass: "ticket-info"
  }, [_vm._v(_vm._s(_vm.ticketid))])]), _vm._v(" "), _c('div', {
    staticClass: "detailBox"
  }, [_c('p', [_vm._v("Cảm ơn quý khách đã tham gia chương trình khuyến mại Đọc tin hay, rinh quà liền tay của công ty TNHH Công Nghệ Mạng Thông Tin Việt Nam. Mọi thông tin về thể lệ chương trình quý khách hàng truy cập vào đường link: "), _c('a', {
    on: {
      "click": _vm.jumpActive
    }
  }, [_vm._v("https://vngaynay.vn/#/introduction.html")]), _vm._v(" hoặc liên hệ đến đầu số 02836362900 để được hỗ trợ")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(" >> Bỏ qua")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40028003","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActiveDetail.vue
// module id = 909
// module chunks = 1